import LettuceTalkLogo from "../images/logo.png";
import { useState } from "react";
import SpeechBubble from "./SpeechBubble";

function FamilyQuestion(props) {
  const familyMembers = [
    "mom",
    "dad",
    "grandparent",
    "sibling",
    "in-laws",
    "pet",
  ];

  const initialSelectedFamily = Object.fromEntries(
    familyMembers.map(member => [member, false])
  );
  const [selectedFamilyMembers, setSelectedFamilyMembers] = useState(initialSelectedFamily);
  const [familyContext, setFamilyContext] = useState("");

  const handleNextClick = () => {
    console.log(selectedFamilyMembers);
    console.log(familyContext);
    const response = {
      familyMembers: selectedFamilyMembers,
      familyContext: familyContext,
    }
    if (props.onNextClick) {
      props.onNextClick(response);
    }
  }

  const handleFamilyContextChange = (e) => {
    const { name, value } = e.target;
    setFamilyContext(value);
  };

  const handleFamilyMemberClick = (member) => {
    // Toggle selected family member
    setSelectedFamilyMembers(previous => ({
      ...previous,
      [member]: !previous[member],
    }));
  }

  return (
    <div className="flex flex-col items-center rounded-lg max-w-lg p-8">
      {/* Header */}
      <img className="w-28" src={LettuceTalkLogo} alt="Lettucetalk logo, a round baby lettuce sitting on top of a parent lettuce" />
      <SpeechBubble
        header="Step 1. Family Dynamics"
        subtitle="First, what does your family look like?"
      />

      <div className="card-body shadow-xl bg-white rounded-3xl mb-4">
        <div className="">In my family, I have at least one:</div>
        <div className="flex flex-row flex-wrap">
          {familyMembers && familyMembers.map((member, index) =>
            <button
              key={index}
              className={`btn m-1 ${selectedFamilyMembers[member] ? "btn-primary" : ""}`}
              onClick={() => handleFamilyMemberClick(member)}
            >
              {member}
            </button>
          )}
        </div>

        <div className="mt-4 mb-2 text-left">Anything else you want to mention about your family dynamics? (optional)</div>
        <textarea
          placeholder="I’m the eldest daughter and close to my mom. I help her take care of my grandpa. My brother lives abroad."
          value={familyContext}
          onChange={handleFamilyContextChange}
          maxLength={260}
          className="textarea textarea-bordered w-full mb-4"
        />
      </div>
      <button
        className="btn btn-primary"
        onClick={handleNextClick}
      >
        Next
      </button>
    </div>
  );
}

export default FamilyQuestion;

